import { Boxes, Loader2, X } from 'lucide-react';

import { JobProgress } from '../components/job-progress.js';
import { cn } from '../lib/cn.js';

export function EmptyRepos(): JSX.Element {
  return (
    <div className="grid place-items-center rounded-2xl border border-dashed border-border-subtle bg-surface/40 px-6 py-16 text-center">
      <div className="grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-accent to-accent-dim text-white shadow-glow">
        <Boxes className="h-7 w-7" />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-text-primary">
        No repositories registered yet.
      </h3>
      <p className="mt-1 max-w-sm text-sm text-text-muted">
        Run{' '}
        <code className="rounded bg-elevated px-1.5 py-0.5 font-mono text-[11px] text-accent">
          wt-codegraph analyze
        </code>{' '}
        from the CLI to register and index your first repository.
      </p>
    </div>
  );
}

export function JobDrawer({
  jobId,
  onClose,
  onTerminal,
}: {
  readonly jobId: string;
  readonly onClose: () => void;
  readonly onTerminal: () => void;
}): JSX.Element {
  return (
    <aside className="rounded-2xl border border-border-subtle bg-surface/80 p-4 shadow-panel backdrop-blur">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="grid h-6 w-6 place-items-center rounded-md bg-accent/15 text-accent">
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          </span>
          <span className="font-mono text-xs text-text-secondary">
            Job <span className="text-text-primary">{jobId}</span>
          </span>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close job drawer"
          className="grid h-7 w-7 place-items-center rounded-md text-text-muted transition-colors hover:bg-hover hover:text-text-primary"
        >
          <X className="h-4 w-4" />
        </button>
      </header>
      <div className="mt-3">
        <JobProgress jobId={jobId} onTerminal={onTerminal} />
      </div>
    </aside>
  );
}

export function PageState({
  icon,
  text,
  tone,
}: {
  readonly icon?: React.ReactNode;
  readonly text: string;
  readonly tone?: 'error';
}): JSX.Element {
  return (
    <div
      className={cn(
        'mx-auto mt-16 flex w-full max-w-md items-center gap-3 rounded-xl border bg-surface/60 px-4 py-3 backdrop-blur',
        tone === 'error'
          ? 'border-rose-500/30 text-rose-300'
          : 'border-border-subtle text-text-secondary',
      )}
    >
      {icon}
      <p>{text}</p>
    </div>
  );
}
